import React from "react";
import { usePhoneTheme } from "../../../../ForBrands/useIsPhone";
import { HighlightTile } from "../../coachPieces";
import { EMPTY } from "../../../../../utils/perfFormat";
import { spotlightOf } from "../teamPerformanceModel";

// Player spotlight on the court (BUILD_SPEC B7, Jayson's T12), from the
// rotation in the makeup: most minutes, the leading scorer and the
// highest-rated (the best average across the five archetype percentiles).
// The same insight tiles as the CACHE spotlight under it (HighlightTile:
// an 84px initials disc on desktop, the 56px row card on phones). Without
// a rotation each tile keeps its place with an en dash and a plain note.

const EMPTY_NOTE = "Appears once the rotation's minutes are on file";
const EYEBROWS = [
  ["minutes", "Most minutes"],
  ["scorer", "Leading scorer"],
  ["rated", "Highest-rated"],
];

const PlayerSpotlight = ({ makeup }) => {
  const phone = usePhoneTheme();
  const layout = phone ? "row" : "tile";
  const picks = spotlightOf(makeup);
  const tiles = picks || EYEBROWS.map(([key, eyebrow]) => ({ key, eyebrow, name: null }));
  return (
    <div role="group" aria-label="On-court spotlight" className={phone ? "flex flex-col gap-3" : "grid gap-4 md:grid-cols-3"}>
      {tiles.map((t) =>
        t.name ? (
          <HighlightTile key={t.key} layout={layout} eyebrow={t.eyebrow} initials={t.initials} title={t.name} chip={t.tag} />
        ) : (
          <HighlightTile key={t.key} layout={layout} eyebrow={t.eyebrow} title={EMPTY} chip={t.emptyNote || EMPTY_NOTE} />
        ),
      )}
    </div>
  );
};

export default PlayerSpotlight;
